import React from 'react'
import { lu } from '../../data/reportData';
import { TITLE, TAB, H1, H2, TXR_B, TXR_I, TXC_B, H1_AMT, TXR_B_AMT } from "../../styles/urar-styles";
import { COMMENTARY, EXHIBITS, TABLE } from "../../styles/urar-styles";

export default function COST_APPROACH() {
	if (!(global.ptr.sowDetail.costApproachIndicator)) return undefined;

	return (
		<>
		<TAB title="Cost Approach" />
		<H1_AMT title="Indicated Value by Cost Approach" amount={lu("25.000")}/>
		<div className='col2 mt-3'>
			<div>
			</div>
			<div>
				<TXR_B_AMT title="Depreciated Cost of Dwellings" value={lu("25.001")} />
				<TXR_B_AMT title="Depreciated Cost of Outbuildings" value={lu("25.002")} />
				<TXR_B_AMT title="As Is Value of Site Improvements" value={lu("25.003")} />
				<TXR_B_AMT title="Opinion of Site Value" value={lu("25.004")} />
			</div>
		</div>

		<COST_DWELLINGS dwellings={lu("25.006.1")} />
		<COST_OUTBUILDINGS dwellings={lu("25.024.1")} />

		{ lu("25.037.1") &&
		<>
			<H1 title="As Is Value of Site Improvements" />
			<TABLE titles={["Description","Amount"]} widths={[576,188]} values={lu("25.037-38")} />
		</>
		}

		<H1 title="Site Value" />
		<div className='flex flex-row mt-1 w-[728px] border-gray-500 border-t-[1px] border-b-[1px]' >
			<div className='w-[260px] mpb' >Prmary Site Valuation Method</div>
			<div className='w-[160px] mpr' >{lu("25.040")}</div>
			<div className='w-[200px] mpb' >Opinion of Site Value</div>
			<div className='w-[108px] bg-gray-500 text-white text-center' >{lu("25.041")}</div>
		</div>


		<H2 title="Land Comparables" />
		<TABLE titles={["#","Address","County","Data Source","Assessor Parcel Number (APN)","Site Size","Sale Date","Price"]} widths={[32,172,138,138,150,150,150,150]} values={lu("25.042-49")} />
		<TXC_B title="Reconciliation of Site Value" value={lu("25.050")} />

		<H1 title="General Description" />
		<div className='col2 mt-3'>
			<div>
				<TXR_B title="Cost Type" value={lu("25.051")} />
				<TXR_B title="Cost Data Source" value={lu("25.052")} />
				<TXR_I title="Quality Rating" value={lu("25.053")} />
				<TXR_I title="Effective Date" value={lu("25.054")} />
			</div>
			<div>
				<TXR_B title="Cost Method" value={lu("25.055")} />
				<TXR_B title="Depreciation Method" value={lu("25.056")} />
			</div>
		</div>

		<COMMENTARY title="Cost Approach Commentary" value={lu("25.057")} />

		<EXHIBITS title="Cost Approach Exhibits" id={["LandComparableMap","CostApproach"]} />

		</>
	)
}

function COST_DWELLINGS({dwellings}) {

	return (
		<>
		{
			dwellings.map((d, di) => {
				return ( <COST_DWELLING key={di} dwelling={d} /> )
			})
		}
		</>
	)
}

function COST_DWELLING({dwelling}) {
	global.ptr.dwelling = dwelling;

	let title = "Depreciated Cost - Dwelling";
	let id = lu("25.005");
	if (id) title += " - " + id;

	return (
		<>
			<H1 title={title} />
			<TABLE titles="" widths={[252,324,108]} values={lu("25.006-17")} />
			<TOTAL total={lu("25.006.2")} />

			<div className='col2 mt-3'>
				<div>
					<TXR_B title="Remaining Economic Life" value={lu("25.019")} />
					<TXR_B title="Effective Age" value={lu("25.020")} />
					<TXC_B title="Commentary on Remaining Economic Life" value={lu("25.021")} />
					<TXC_B title="Commentary on Effective Age" value={lu("25.022")} />
				</div>
				<div>
				</div>
			</div>
		</>
	)
}

function COST_OUTBUILDINGS({dwellings}) {

	return (
		<>
		{
			dwellings.map((d, di) => {
				return ( <COST_OUTBUILDING key={di} dwelling={d} /> )
			})
		}
		</>
	)
}

function COST_OUTBUILDING({dwelling}) {
	global.ptr.dwelling = dwelling;
	let title = "Depreciated Cost - Outbuilding";
	let id = lu("25.023");
	if (id) title += " - " + id;

	return (
		<>
			<H1 title={title} />
			<TABLE titles="" widths={[232,344,108]} values={lu("25.024-35")} />
			<TOTAL total={lu("25.006.2")} />
		</>
	)
}

function TOTAL({total}) {

	return (
		<div className='flex flex-row w-[680px] border-gray-600 border-t-2 mpb' >
			<div className='w-[400px]' />
			<div className='w-[172px] bg-gray-600 text-right text-white pr-2' >Total</div>
			<div className='w-[108px] text-right text-white pr-4 bg-gray-600' >{total}</div>
		</div>
	)
}
